<div class="lang-switch glass-card" [class.expanded]="expanded">
  <button *ngIf="showSelected" class="selected" (click)="toggle()" [attr.aria-label]="'Current language ' + current">
    <span class="flag">{{ selected?.flag }}</span>
    <span class="code">{{ selected?.label }}</span>
  </button>
  <div class="options">
    <button *ngFor="let locale of locales"
            (click)="changeLocale(locale.code)"
            [class.active]="locale.code === current"
            [attr.aria-label]="'Switch to ' + locale.label">
      <span class="flag">{{ locale.flag }}</span>
      <span class="code">{{ locale.label }}</span>
    </button>
  </div>
</div>

<div class="lang-dialog" *ngIf="dialogOpen" (click)="closeDialog()">
  <div class="dialog-content glass-card" (click)="$event.stopPropagation()">
    <div class="dialog-title">{{ 'app.title' | t }}</div>
    <div class="dialog-options">
      <button *ngFor="let locale of locales"
              (click)="changeLocale(locale.code)"
              [class.active]="locale.code === current">
        <span class="flag">{{ locale.flag }}</span>
        <span class="code">{{ locale.label }}</span>
      </button>
    </div>
  </div>
</div>
